import React from 'react'

const Mt13 = () => {
    return (
        <div className='container'>
            <h1>Lexicographically next permutation</h1>
             <div class="tabs">
    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
   
    
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
          
       </div>
     
     </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
        </div>
    )
}

export default Mt13
